<template>
  <div
    class="ce-colorBadge-holder"
    v-on="eventListeners">
    <tooltip
      v-if="withTooltip"
      :content="color.title"
      class="ce-colorBadge"
      :class="classes"
      :style="{backgroundImage: hasImage ? `url(${color.image})` : ''}"
      placement="bottom" />

    <span
      class="ce-colorBadge"
      :class="classes"
      :style="{backgroundImage: hasImage ? `url(${color.image})` : ''}"
      v-else />
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: Object,
      required: true,
    },
    interactive: {
      type: Boolean,
      default: false,
    },
    withTooltip: {
      type: Boolean,
      default: false,
    },
    withShadow: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    hasImage() {
      return !!this.color.image;
    },
    classes() {
      const classes = [
        {
          selected: this.color.selected,
          disabled: this.color.disabled
        }
      ];

      if (this.interactive) {
        classes.push('ce-colorBadge--interactive');
      }

      if (this.withShadow) {
        classes.push('ce-colorBadge--withShadow');
      }

      if (this.hasImage) {
        classes.push('ce-colorBadge--withImage');
      } else {
        classes.push(`ce-colorBadge--${this.color.code}`);
      }

      return classes;
    },
    eventListeners() {
      const listeners = {};

      if (this.interactive) {
        listeners.click = this.toggle;
      }

      return listeners;
    }
  },
  methods: {
    toggle() {
      if (this.interactive) {
        this.$emit('toggle', this.color);
      }
    }
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';
.ce-colorBadge-holder {
  .ce-colorBadge {
    margin: @space-1 (@space-1 / 2);
    display: block;
    width: 33px;
    height: 33px;
    border-radius: @border-radius;
    border: 1px solid @color-mono-70;
    transition: all 250ms ease-in-out;

    &.selected {
      .ce-selectedBadge;
    }

    &.disabled {
      opacity: 0.2;
      cursor: not-allowed;
    }

    &--withImage {
      background-size: cover;
    }

    &--interactive {
      cursor: pointer;
    }

    &--withShadow {
      box-shadow: 2px 2px 4px fade(@color-mono-10, 20);
    }
  }
}
</style>
